import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiTranslationNavigationTabsComponent } from './fi-translation-navigation-tabs.component';
import { UIRouterModule } from '@uirouter/angular';
import { TranslationStates } from '@fi-app/fi-translation/fi-translation-states';
import { FiTranslationListComponent } from './fi-translation-list/fi-translation-list.component';
import { FiTabsModule } from '@fi-app/utilities/tabs/tabs.module';
import { FiTranslationService } from '@fi-app/fi-translation/fi-translation.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FormsModule } from '@angular/forms';
import { FiTranslationItemComponent } from './fi-translation-item/fi-translation-item.component';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { MatButtonModule } from '@angular/material/button';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { MatCardModule } from '@angular/material/card';
import { FiToggleSwitchModule } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.module';
import { MatIconModule } from '@angular/material/icon';
import { FiImportLabelsDialogComponent } from './fi-import-labels-dialog/fi-import-labels-dialog.component';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        UIRouterModule.forChild(TranslationStates),
        FiTabsModule,
        FiAppTextSharedModule,
        FiValidatingFormModule,
        FiWhenScrolledModule,
        SelectSearchModule,
        FiToggleSwitchModule,
        MatIconModule,
        FiLoadingModule,
        MatSelectModule,
        MatRadioModule,
        FiWrapperTableModule,
        MatCheckboxModule,
    ],
    declarations: [
        FiTranslationNavigationTabsComponent,
        FiTranslationListComponent,
        FiTranslationItemComponent,
        FiImportLabelsDialogComponent,
    ],
    providers: [FiTranslationService],
})
export class FiTranslationModule {}
